import { useEffect, useState } from "react";
import { motion } from "framer-motion";


const Home = () => {
    return (
    <motion.div className="home"
    initial={{opacity: 0}} 
    animate={{opacity: 1}} 
    exit={{x: -300}}
    transition={{duration:0.5}}
    >
        <div className="home-img-cont">
            <img className="melol" src="/images/melol.JPG" alt="" width="100%"/>
        </div>
        <motion.div className="introduction"
            initial={{opacity: 0, y: -150}} 
            animate={{opacity: 1, y: -10}} 
            transition={{delay: 0.7, type:"spring", stiffness: 500 ,duration:0.5}}
        
        >
            <h4>Hello, I'm</h4>
            <h3>
                Matthew Puyat
            </h3>
            <p>I'm a developer</p>

        </motion.div>

    </motion.div>  );
}
 
export default Home;<div className="home">
</div>